export const SportCardProvider = {
  Medicover: 'medicoverSport',
}
